import Vue from 'vue'
import App from './App.vue'
import VueSignaturePad from 'vue-signature-pad'
import VueApexCharts from 'vue-apexcharts'
import store from '@/plugins/store/index.js'
import vuetify from '@/plugins/vuetify/index.js'
import { i18n } from '@/plugins/i18n/index.js'
import router from '@/plugins/router/index.js'
import filters from '@/plugins/filters/index.js'
import '@mdi/font/css/materialdesignicons.css'
import * as VueGoogleMaps from 'vue2-google-maps'
//import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
Vue.config.productionTip = false
Vue.use(VueSignaturePad)
Vue.use(filters)
Vue.use(VueGoogleMaps, {
	load: {
		key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY || '',
		libraries: 'places', // Add any additional libraries you need
	},
})
/*Vue.use(TiptapVuetifyPlugin, {
	// the next line is important! You need to provide the Vuetify Object to this place.
	vuetify, // same as "vuetify: vuetify"
	// optional, default to 'md' (default vuetify icons before v2.0.0)
	iconsGroup: 'md'
})*/
new Vue({
	vuetify,
	router,
	store,
	i18n,
	VueApexCharts,
	render: h => h(App),
}).$mount('#app')